/**
 * The order of the menu categories inside one restaurant.
 *
 * `vendorUserId` is the restaurant's USER id, the same id as a product's
 * `vendorId`. Pure axios wrappers, one per endpoint.
 */
import { api } from "api";

/**
 * @typedef {object} MenuCategory
 * @property {number} id
 * @property {string} name
 * @property {string} image
 * @property {number} totalProducts
 * @property {boolean} placed - false: the restaurant did not place it yet
 */

/**
 * The restaurant's menu categories, in the order the customer sees.
 *
 * @param {number|string} vendorUserId
 * @returns {Promise<{results: MenuCategory[], custom: boolean}>}
 */
export const getCategoryOrder = async (vendorUserId) => {
    const response = await api.get(`vendor/${vendorUserId}/category-order`);
    return response.data;
};

/**
 * Saves the order. `categoryIds` is every category of the menu. The API
 * answers 409 when the menu changed in the meantime.
 */
export const saveCategoryOrder = async (vendorUserId, categoryIds) => {
    const response = await api.put(`vendor/${vendorUserId}/category-order`, { categoryIds });
    return response.data;
};

/** Removes the restaurant's own order: the menu returns to the global order. */
export const resetCategoryOrder = async (vendorUserId) => {
    const response = await api.delete(`vendor/${vendorUserId}/category-order`);
    return response.data;
};
